import React, { CSSProperties, FunctionComponent, useState } from 'react';
import PropertyPalCheck from '../forms/checkbox/PropertyPalCheck';
import { CheckBorder, Container, HiddenInput, Label } from './Checkbox.style';

interface Props {
  containerStyle?: CSSProperties;
  name: string;
  label: string;
  onValueChange: (value: boolean) => void;
  value: boolean;
}

const Checkbox: FunctionComponent<Props> = (props) => {
  const [checked, setChecked] = useState(props.value);

  return (
    <Container style={props.containerStyle}>
      <CheckBorder>
        <HiddenInput
          id={props.name}
          name={props.name}
          type="checkbox"
          defaultChecked={checked}
          onChange={() => {
            props.onValueChange(!checked);
            setChecked(!checked);
          }}
        />

        {checked && <PropertyPalCheck />}
      </CheckBorder>

      <Label htmlFor={props.name}>{props.label}</Label>
    </Container>
  );
};

export default Checkbox;
